export default {
    namespaced: true,
    alarm_rules: {
        title: "Regras",
        rule_id: "ID",
        name: "Nome",
        description: "Descrição",
        user_id: "Usuário",
        tenant_id: "Tenant",
    },
    match_rules: {
        name_label: "Insira o nome identificador",
        description_label: "Insira a descrição",
        tenant_label: "Atribua tenants à regra",
        alarm_type_label: "Atribua o tipo de alarme à regra",

        general: "Dados gerais da regra",
        providers: "Fornecedores",
        camera: "Câmeras",
        table: "Tabela de correspondências",

        assign_camera: "Atribuir câmeras",
        main_camera: "Selecione as câmeras para atribuir",
        main_provider: "Selecione os fornecedores para atribuir",
        assign_provider: "Atribuir provedores",
        main_provider: "Selecione o provedor ao qual deseja atribuir as coincidências",
        second_provider: "Selecione um provedor para exibir seu catálogo de campos",
        missing_provider: "Você deve selecionar um provedor",
        min_match_rule: "Você deve adicionar pelo menos uma coincidência",
        new_match_rule: "Adicionar nova coincidência",

        tenant: "Tenant",
        name: "Nome da regra",
        description: "Descrição",
        provider: "Provedor",
        alarm_type: "Tipo de alarme",

        field: "Catálogo de campos",
        action: "Ação",
        type: "Tipo",
        value: "Valor"
    },
    match_rules_action: {
        contains: "Contém",
        equal_to: "Igual a",
        no_equal_to: "Diferente de",
        greater_than: "Maior que",
    },
    match_rules_card: {
        camera_applied: "As correspondências serão aplicadas apenas se as câmeras forem:",
        provider_applied: "As correspondências serão aplicadas apenas se os fornecedores forem:",
        match_rule_table: "A tabela de correspondências se aplica apenas aos fornecedores, câmeras e locatários atribuídos",

        apply_to: "Aplicar correspondência:",
        on_param: "No parâmetro:",
        with_values: "Com valor: | Com valores:"
    }
};